import styled from '@emotion/styled';

import BaseCard from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: 4rem 0;
`;

export const Card = styled(BaseCard)`
	border-radius: 3rem !important;
	min-height: inherit;
	max-width: 85rem;
	width: 100%;
	padding: 5rem 4rem;
	@media ${Breakpoints.mobile} {
		padding: 3rem 2rem;
	}
`;

export const CardTitleContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 2.5rem;
	.order-number {
		display: inline;
	}
`;

export const OrderInfoContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	flex-wrap: wrap;
	gap: 2rem 1rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const Line = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--border-color);
	margin: 4rem 0;
`;

export const OrderTrackingContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 2.5rem;
`;

export const TimeLineRow = styled.div`
	position: absolute;
	top: 3.5rem;
	left: 4rem;
	height: 100%;
	border-left: 1px dashed var(--blue);
	z-index: -1;
	${({ isCurrentStep }) => isCurrentStep && 'filter: grayscale(1);'}
	body[dir='rtl'] & {
		right: 4rem;
		left: initial;
	}
`;

export const StepRow = styled.div`
	width: 100%;
	display: flex;
	gap: 3rem;
	z-index: 1;
	${({ isGrayScale }) => isGrayScale && 'filter: grayscale(1);'}
	position: relative;
	padding: 1rem;
	background: ${({ isCurrentStep }) => (isCurrentStep ? 'var(--input-disabled-bg-color)' : 'initial')};
	border-radius: var(--medium-border-radius);
`;

export const StepContent = styled.div`
	display: flex;
	width: 100%;
`;

export const StepInfo = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: space-between;
	gap: 1rem;
`;

export const AccordionInner = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const TopInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const DCContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.64rem;
`;

export const DCLogoContainer = styled.div`
	width: 5.5rem;
	height: 5.5rem;
	border-radius: 4px;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
	}
`;

export const DCInfoContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	a {
		text-decoration: none;
	}
`;
